<template lang="pug">
  .kaffeehaus
    h1(v-html='headline')
    seperator
    .body
      p(v-for='paragraph in body', v-html='paragraph')
      form(v-on:submit.prevent='submitForm', action='http://donauhofwien.at/mailchimp.php', method='put')
        label.name
          input(type='text', placeholder='Name', value='', name='NAME', v-model='form.name' required, :disabled='form.response')
        label.email
          input(type='email', placeholder='Email Adresse', value='', name='EMAIL', v-model='form.email', :disabled='form.response')
        button.cta(type='submit', :disabled='form.response') Anmelden
      transition(v-if='form.response', name='response', mode='out-in', appear)
        p.response(v-html='form.response', :key='form.response')
    .clear
</template>

<script>
  import axios from 'axios'
  import seperator from '@/components/Seperator'
  export default {
    components: {
      seperator
    },
    data () {
      return {
        title: 'Kaffeehaus',
        indicator: require('@/assets/img/donauhof-cafe.svg'),
        image: require('@/assets/img/donauhof-cafe-image.jpg'),
        background: {
          rotate: -60,
          scale: {
            x: 4,
            y: 16
          },
          translate: {
            x: '-50%',
            y: '0%'
          }
        },
        headline: '2018 bekommt der Donauhof ein Kaffeehaus.',
        body: [
          'Die Räumlichkeiten sind für vereinzelte Veranstaltungen schon dieses Jahr mietbar (Auch in Kombination mit dem Ballsaal).',
          'Wir halten euch gerne auf dem Laufenden.'
        ],
        form: {
          name: '',
          email: '',
          response: false
        }
      }
    },
    head () {
      return {
        title: this.title
      }
    },
    methods: {
      submitForm () {
        let self = this
        const form = document.querySelector('form')
        let formdata = new FormData(form)
        axios.post(form.getAttribute('action'), formdata)
          .then(function (response) {
            console.log(response)
            self.form.response = response.data
            setTimeout(() => {
              self.form.response = false
              self.form.email = ''
              self.form.name = ''
            }, 30000)
          })
          .catch(function (error) {
            console.log(error)
            self.form.response = error.data
          })
        // let self = this
        // if (!this.$refs.cta.submitting && this.form.submit.success !== true) {
        //   this.form.submit.success = null
        //   this.form.submit.error = null
        //   this.$refs.cta.error = false
        //   this.$refs.cta.success = false
        //   self.$refs.cta.submitting = true
        //   var form = document.querySelector('form')
        //   var formdata = new FormData(form)
        //   // console.log(formdata)
        //   // console.log(this.form.data)
        //   axios.post('http://santos-bar.com/santos_application.php', formdata)
        //   .then(function (response) {
        //     self.$refs.cta.submitting = false
        //     self.$refs.cta.success = true
        //     self.form.submit.success = true
        //     self.$scrollTo(document.querySelector('.response'), 2500)
        //     console.log(response)
        //   })
        //   .catch(function (error) {
        //     self.$refs.cta.submitting = false
        //     self.$refs.cta.error = true
        //     self.form.submit.error = true
        //     console.log(error)
        //     self.$scrollTo(document.querySelector('.response'), 2500)
        //   })
        // }
      }
    }
    // created () {
    //   this.$parent.currentIndicator = this.indicator
    //   this.$parent.currentImage = this.image
    // }
  }
</script>

<style lang="scss" scoped>
  @import "~utils";
  .body {
    text-align: center;
    form {
      margin: $gutter*5 0 0;
      label {
        text-align: center;
        max-width: 12rem;
        margin: 0 auto;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 23.1 3.6'%3E %3Cpath fill='none' stroke='%23B2DCDA' stroke-miterlimit='10' d='M0 .5c2.9 0 3.1 2.6 5.8 2.6 3 0 2.6-2.6 5.7-2.6 2.8 0 3.3 2.6 5.8 2.6 3 0 2.8-2.6 5.8-2.6'/%3E %3C/svg%3E");
        background-size: auto 5px;
        background-position: center bottom;
        background-repeat: repeat-x;
        input {
          @include serif;
          border: none;
          background: transparent;
          text-align: center;
          margin: 1.5rem auto 0;
          position: relative;
          padding-bottom: 1rem;
          transition: all .25s $easeOut;

          &:disabled {
            color: $light-grey;
            transition: all .25s $easeOut;
          }

          &:focus {
            background: transparent;
          }
        }
      }
      .cta {
        margin-top: $gutter*2;
        &:disabled {
          color: $blue !important;
          outline: 2px solid $blue !important;
          transition: all .25s $easeOut !important;
          &:before, &:after {
            background: $blue !important;
            transition: all .25s $easeOut !important;
          }
        }
      }
    }
    p.response {
      margin: 0 auto;
      margin-top: $gutter;
      text-align: center !important;
      font-size: 0.875rem !important;
      color: $gold;
      max-width: 24rem;
    }
  }

  // response transition
.response-enter, .response-leave-to {
  opacity: 0;
  transform: translate3d(0, 25px, 0) rotate3d(0,0,1,5deg);
}

.response-enter-to, .response-leave {
  opacity: 1;
  transform: translate3d(0, 0, 0) rotate3d(0,0,1,0deg);
}

.response-enter-active, .response-leave-active {
  transition: all .5s $easeOut;
  transform-origin: left top;
}
</style>



// WEBPACK FOOTER //
// Kaffeehaus.vue?538ec276